import { render, staticRenderFns } from "./customselectCOA.vue?vue&type=template&id=042fc520"
import script from "./customselectCOA.vue?vue&type=script&lang=js"
export * from "./customselectCOA.vue?vue&type=script&lang=js"
import style0 from "./customselectCOA.vue?vue&type=style&index=0&id=042fc520&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports